// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8bde1855","977":"3b24ced5"}[chunkId] + ".chunk.js";
};